import { DealerResponse } from '../types/dealers';

export interface DealersParams {
  address: string;
  dealerization_postal_code: string;
  km?: number;
}

export const fetchDealers = async (
  baseUrl: string,
  params: DealersParams
) => {
  const urlQueries = Object.keys(params).map((x) => `${x}=${params[x as keyof DealersParams] as string}`);
  const urlParams = urlQueries.join("&");
  const url = `${baseUrl}/inventory-app/dealers?${urlParams}`;

  const response = await fetch(url);

  if (!response.ok) return { data: [] };

  return await response.json() as DealerResponse;
};
